var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isH5)?_c('div',{staticClass:"course-status",class:{
    'h5-course-status': _vm.isH5,
    'electron-course-status': _vm.isElectron,
  }},[(_vm.liveState === 1)?_c('div',{staticClass:"living-tag"},[_c('img',{attrs:{"src":require("../../../assets/images/course-card/living.gif"),"alt":""}}),_c('span',[_vm._v("直播中")])]):(_vm.trialState === 1)?_c('div',{staticClass:"can-trial-tag"},[_c('img',{attrs:{"src":require("../../../assets/images/course-card/play-icon.png"),"alt":""}}),_c('span',[_vm._v("试听")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }